/** Evita import circular entre axios (common) y el store de auth. */

let accessToken: string | null = null;

export function setBridgeAccessToken(token: string | null): void {
  accessToken = token;
}

export function getBridgeAccessToken(): string | null {
  return accessToken;
}
